import React, { useState, useEffect } from "react";
import { Modal, Table, Input, Button, message, Spin, Select } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import { http } from "../../services/http";
import moment from "moment";
import { numberWithSpacesIntl } from "../../utils/numberWithSpaces";
import LoadersIcon from "../../assets/icons/LoadersIcon";
import {
  loadersPdfStockTransfers,
  stockTransfersPdf,
} from "../../utils/navigateToPDF";
import CarIcon3 from "../../assets/icons/CarIconV3";
import { useSelector } from "react-redux";

const InventoryTransfersModal = ({
  visible,
  data,
  onClose,
  showCancelBtn = false,
  showReceivingLoaderBtn = false,
  showShippingLoaderBtn = false,
  showShipBtn = false,
  showReceiveBtn = false,
  isEditDriverAndLoaders = false,
  isEditGivingQuantity = false,
  isShowGivingQuantity = true, // Bu bitta canceledlarda korinmasligi kerak
  isShowReceivedQuantity = false,
  isEditReceivedQuantity = false,
  showShippingLoaders = false,
  showReceivingLoaders = false,
  isShowLoaderPdfReceiving = true,
  isShowLoaderPdfShipping = true,
  isShowDriverPdf = true,
  isShowDriverPdfExact = false,
  isBuferWhs = false,
  isInTransitMenu = false,
  isInventoryRequestMenu = false,
}) => {
  const { t } = useTranslation();
  const { warehouse } = useSelector((state) => state.main);
  console.log("GetMe Whs", warehouse);

  const [responsiblePersonData, setResponsiblePersonData] = useState([]);
  const [responsiblePerson, setResponsiblePerson] = useState("");
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [loading3, setLoading3] = useState(false);
  const [loadingCancelBtn, setLoadingCancelBtn] = useState(false);
  const [carNum, setCarNum] = useState("");
  const [driverId, setDriverId] = useState("");
  const [loadersReceiving, setLoadersReceiving] = useState([]);
  const [loadersShipping, setLoadersShipping] = useState([]);
  const [loadingDrivers, setLoadingDrivers] = useState(false);
  const [driversData, setDriversData] = useState([]);
  const [loadingLoaders, setLoadingLoaders] = useState(false);
  const [loadersData, setLoadersData] = useState([]);
  const [selectedReceivingLoadersAllData, setSelectedReceivingLoadersAllData] =
    useState([]);
  const [selectedShippingLoadersAllData, setSelectedShippingLoadersAllData] =
    useState([]);
  const [pdfData, setPdfData] = useState(null);
  const [docLines, setDocLines] = useState([]);
  const [loadingLoaderBtn, setLoadingLoaderBtn] = useState(false);
  const [receivingLoaderBtnClicked, setReceivingLoaderBtnClicked] =
    useState(false); //Bunda agar oldin button bosilmagan bolsa Birinchi shu button bosiladi kyn receiveData
  const [shippingLoaderBtnClicked, setShippingLoaderBtnClicked] =
    useState(false); //Bunda agar oldin button bosilmagan bolsa Birinchi shu button bosiladi kyn shipData
  const [carNumbers, setCarNumbers] = useState([]);

  useEffect(() => {
    fetchResponsibleManagers();
    fetchDrivers();
    fetchLoadersData();
    fetchCarNumbers();
  }, []);

  useEffect(() => {
    if (!data) return;

    setCarNum(data?.u_CarNumber);
    setDriverId(data?.u_Driver);
    getLoadersReceiving(data?.u_StEmployeesWeb);
    getLoadersShipping(data?.u_DeliveryID);
    setPdfData(data);

    const itemCodes = data?.stockTransferLines
      .map((item) => item.itemCode)
      .join(",");

    (async () => {
      const fetchedData = await fetchOnHandQuantity(
        itemCodes,
        data?.fromWarehouse,
      );

      const mappedLines = data.stockTransferLines.map((item) => {
        const onHandItem = fetchedData.find(
          (fetchedItem) => fetchedItem.itemCode === item.itemCode,
        );

        console.log("On hand:", onHandItem);

        return {
          ...item,
          givingQuantity: !isInventoryRequestMenu
            ? item.u_GivenQuantityWeb
            : item.quantity,
          receivedQuantity: !isInTransitMenu
            ? item.u_ReceivedQuantityWeb
            : item.u_GivenQuantityWeb,
          onHandQuantity: onHandItem ? onHandItem.onHand : 0,
          whsOnHandQuantity: onHandItem ? onHandItem.onHand : 0,
          whsAvailableQuantity: onHandItem ? onHandItem.available : 0,
          u_RequestedQuantityWeb: item.u_RequestedQuantityWeb || item.quantity,
        };
      });

      setDocLines(mappedLines);
      setPdfData((prevState) => ({
        ...prevState,
        documentLines: mappedLines,
      }));
    })();
  }, [data]);

  const columns = [
    {
      title: t("item"),
      dataIndex: "itemDescription",
      key: "itemDescription",
    },
    {
      title: t("requestedQuantity"),
      dataIndex: "u_RequestedQuantityWeb",
      key: "u_RequestedQuantityWeb",
      render: (text) => `${numberWithSpacesIntl(text)}`,
    },

    {
      title: t("whsOnHand"),
      dataIndex: "whsAvailableQuantity",
      key: "whsAvailableQuantity",
      render: (text, record) =>
        isShowGivingQuantity
          ? `${numberWithSpacesIntl(text + record.u_RequestedQuantityWeb)}`
          : `${numberWithSpacesIntl(text)}`,
    },

    // givingQuantity will be inserted here conditionally
    // receivedQuantity will be inserted here conditionally
    {
      title: t("weight"),
      dataIndex: "weight",
      key: "weight",
      render: (text, record, index) => {
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {`${isInventoryRequestMenu ? numberWithSpacesIntl(text * record.givingQuantity) : numberWithSpacesIntl(text * record.receivedQuantity)} `}
          </span>
        );
      },
    },
    {
      title: t("Hajmi"),
      dataIndex: "volume",
      key: "volume",
      render: (text, record, index) => {
        return (
          <span
            className={`${record.lineStatus === "C" ? "text-slate-500" : "text-black"}`}
          >
            {`${isInventoryRequestMenu ? numberWithSpacesIntl(text * record.givingQuantity) : numberWithSpacesIntl(text * record.receivedQuantity)} `}
          </span>
        );
      },
    },
    {
      title: t("from-whs"),
      dataIndex: "fromWarehouseName",
      key: "fromWarehouseName",
    },
    {
      title: t("toWhs"),
      dataIndex: "warehouseName",
      key: "warehouseName",
    },
  ];

  if (isShowGivingQuantity) {
    columns.splice(2, 0, {
      title: t("givingQuantity"),
      dataIndex: "givingQuantity",
      key: "givingQuantity",
      render: (text, record, index) =>
        isEditGivingQuantity ? (
          <Input
            value={text}
            className={`${text > record.whsAvailableQuantity + record.u_RequestedQuantityWeb ? "border-red-500" : ""}`}
            onChange={(e) => {
              const newDocLines = [...docLines];
              newDocLines[index].givingQuantity = e.target.value;
              setDocLines(newDocLines);
            }}
            disabled={record.fromWarehouseCode !== warehouse}
          />
        ) : (
          <span>{text}</span>
        ),
    });
  }
  if (isShowReceivedQuantity) {
    columns.splice(3, 0, {
      title: t("receivedQuantity"),
      dataIndex: "receivedQuantity",
      key: "receivedQuantity",
      render: (text, record, index) =>
        isEditReceivedQuantity ? (
          <div>
            <Input
              value={text}
              onChange={(e) => {
                const newDocLines = [...docLines];
                newDocLines[index].receivedQuantity = e.target.value;
                setDocLines(newDocLines);
              }}
              className={`${record.receivedQuantity > record.givingQuantity ? "border-red-500" : ""}`}
              disabled={record.warehouseCode !== warehouse}
            />
            {/* {record.receivedQuantity > record.givingQuantity && (
              <span style={{ color: "red" }}>
                {t("quantityMoreThanWhsOnHand")}
              </span>
            )} */}
          </div>
        ) : (
          <span>{isBuferWhs ? record.quantity : text}</span>
        ),
    });
  }

  const fetchResponsibleManagers = async () => {
    try {
      const { data } = await http.get(
        `api/sales/warehouse-employee-info?skip=0`,
      );
      setResponsiblePersonData(data.data);
      console.log("warehouse-employee", data.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDrivers = async () => {
    setLoadingDrivers(true);
    try {
      const { data } = await http.get(
        `api/sales/driver-business-partners?skip=0`,
      );
      setDriversData(data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingDrivers(false);
    }
  };

  const fetchCarNumbers = async () => {
    try {
      const { data } = await http.get(
        `api/inventorytransferrequest/car-numbers`,
      );
      setCarNumbers(data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchOnHandQuantity = async (itemCodes, fromWhs) => {
    try {
      const { data } = await http.get(
        `api/items/ombordagiitems/on-hand-items?itemCodes=${itemCodes}&whsCode=${fromWhs}`,
      );
      return data;
    } catch (error) {
      console.log("Error:", error.message);
    }
  };

  const fetchLoadersData = async () => {
    setLoadingLoaders(true);
    try {
      const { data } = await http.get(
        `api/warehouseassistant/employee-business-partners?skip=0`,
      );

      setLoadersData(data.data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingLoaders(false);
    }
  };

  const getLoadersReceiving = async (docEntry) => {
    if (!docEntry) {
      setLoadersReceiving([]);
      setSelectedReceivingLoadersAllData([]);
      setReceivingLoaderBtnClicked(false);
      return;
    }
    setLoadingLoaders(true);
    try {
      const { data } = await http.get(
        `api/inventorytransferrequest/employee/${docEntry}`,
      );
      const resData = data?.sT_EMPLOYEES_ROWSCollection;
      const loaders = resData?.map((item) => item?.u_EmployeeId) || []; //Bu Selecda getida kelganlar tanlanib qolishi uchun qilindi
      const loadersName = resData
        ?.map((item) => item?.u_EmployeeName)
        .join(", ");
      const selectedDataLoaders = resData.map((item, index) => ({
        data: {
          cardCode: item.u_EmployeeId,
          cardName: item.u_EmployeeName,
        },
      })); // Bu Backendga jonatvotgan selectda shunaqa tartibda olinganakan shunichun yozildi bu
      setLoadersReceiving(loaders);
      setSelectedReceivingLoadersAllData(selectedDataLoaders);
      setReceivingLoaderBtnClicked(true);
      setPdfData((prevState) => ({
        ...prevState,
        receivingLoaderNames: loadersName,
      }));
      console.log("loaderNames", loadersName);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingLoaders(false);
    }
  };

  const getLoadersShipping = async (docEntry) => {
    if (!docEntry) {
      setLoadersShipping([]);
      setSelectedShippingLoadersAllData([]);
      setShippingLoaderBtnClicked(false);
      return;
    }
    setLoadingLoaders(true);
    try {
      const { data } = await http.get(
        `api/deliverynotesdata/get-employees?docEntry=${docEntry}`,
      );
      const resData = data[0]?.documentLines || [];
      const loaders = resData?.map((item) => item?.employeeID) || []; //Bu Selecda getida kelganlar tanlanib qolishi uchun qilindi
      const loadersName = resData?.map((item) => item?.employeeName).join(", ");
      const selectedDataLoaders = resData.map((item, index) => ({
        data: {
          cardCode: item.employeeID,
          cardName: item.employeeName,
        },
      })); // Bu Backendga jonatvotgan selectda shunaqa tartibda olinganakan shunichun yozildi bu
      setLoadersShipping(loaders);
      setSelectedShippingLoadersAllData(selectedDataLoaders);
      setPdfData((prevState) => ({
        ...prevState,
        shippingLoaderNames: loadersName,
      }));
      setShippingLoaderBtnClicked(true);
    } catch (err) {
      console.log(err);
    } finally {
      setLoadingLoaders(false);
    }
  };

  const postLoadersShipping = async () => {
    setLoadingLoaderBtn(true);
    const employeeLines = selectedShippingLoadersAllData.map((item, index) => ({
      lineId: index + 1,
      employeeId: item.data.cardCode,
      employeeName: item.data.cardName,
    }));

    const postingData = {
      docEntry: data?.docEntry,
      employeeLines,
    };

    try {
      await http.post(
        `/api/inventorytransferrequest/attach-employee/delivery?docEntry=${data?.docEntry}`,
        postingData,
      );
      message.success(t("sucCreated"));
      setShippingLoaderBtnClicked(true);
      onClose();
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoadingLoaderBtn(false);
    }
  };

  const patchLoadersShipping = async () => {
    setLoadingLoaderBtn(true);
    const employeeLines = selectedShippingLoadersAllData.map((item, index) => ({
      lineId: index + 1,
      employeeId: item.data.cardCode,
      employeeName: item.data.cardName,
    }));

    const postingData = {
      docEntry: data?.u_DeliveryID,
      employeeLines,
    };

    try {
      await http.patch(
        `/api/inventorytransferrequest/employee/delivery/${data?.u_DeliveryID}`,
        postingData,
      );
      message.success(t("sucEdit"));
      setShippingLoaderBtnClicked(true);
      onClose();
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoadingLoaderBtn(false);
    }
  };

  const handleShippingLoadersBtnClick = async () => {
    if (shippingLoaderBtnClicked) {
      patchLoadersShipping();
    } else {
      postLoadersShipping();
    }
  };

  const postLoadersReceiving = async () => {
    setLoadingLoaderBtn(true);
    const employeeLines = selectedReceivingLoadersAllData.map(
      (item, index) => ({
        lineId: index + 1,
        employeeId: item.data.cardCode,
        employeeName: item.data.cardName,
      }),
    );

    const postingData = {
      docEntry: data?.docEntry,
      employeeLines,
    };

    try {
      await http.post(
        `/api/inventorytransferrequest/attach-employee?docEntry=${data?.docEntry}`,
        postingData,
      );
      message.success(t("sucCreated"));
      setReceivingLoaderBtnClicked(true);
      onClose();
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoadingLoaderBtn(false);
    }
  };
  const patchLoadersReceiving = async () => {
    setLoadingLoaderBtn(true);
    const employeeLines = selectedReceivingLoadersAllData.map(
      (item, index) => ({
        lineId: index + 1,
        employeeId: item.data.cardCode,
        employeeName: item.data.cardName,
      }),
    );

    const postingData = {
      docEntry: data?.u_StEmployeesWeb,
      employeeLines,
    };

    try {
      await http.patch(
        `/api/inventorytransferrequest/employee/${data?.u_StEmployeesWeb}`,
        postingData,
      );
      message.success(t("sucEdit"));
      setReceivingLoaderBtnClicked(true);
      onClose();
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoadingLoaderBtn(false);
    }
  };

  const handleReceivingLoadersBtnClick = async () => {
    if (receivingLoaderBtnClicked) {
      patchLoadersReceiving();
    } else {
      postLoadersReceiving();
    }
  };

  const shipData = async () => {
    setLoading2(true);
    const stockTransferLines = docLines?.map((item, idx) => {
      return {
        lineNum: item.lineNum,
        quantity: item.quantity,
        u_RequestedQuantityWeb: String(item.quantity),
        u_GivenQuantityWeb: String(item.givingQuantity),
      };
    });
    const patchData = {
      docEntry: data?.docEntry,
      u_StatusWeb: "В пути",
      u_TransferTimeWeb: moment().format("YYYY-MM-DD HH:mm:ss"),
      u_Driver: driverId,
      u_CarNumber: carNum,
      stockTransferLines,
    };
    try {
      await http.patch(`api/inventorytransferrequest/status`, patchData);
      message.success(t("sucEdited"));

      setTimeout(() => {
        onClose();
      }, 800);
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoading2(false);
    }
  };

  const createStockTransfer = async () => {
    setLoading3(true);
    const stockTransferLines = docLines?.map((item, idx) => {
      return {
        lineNum: idx,
        itemCode: item.itemCode,
        baseEntry: data?.docEntry,
        quantity: item.quantity,
        baseLine: item.lineNum,
        u_RequestedQuantityWeb: String(item.quantity),
        u_GivenQuantityWeb: String(item.givingQuantity),
        u_ReceivedQuantityWeb: String(item.receivedQuantity),
        warehouseCode: item.warehouseCode,
        fromWarehouseCode: item.fromWarehouseCode,
      };
    });
    const patchData = {
      docDate: moment().format("YYYY-MM-DD"),
      stockTransferLines,
    };
    try {
      await http.post(
        `api/inventorytransferrequest/stock-transfer/receive`,
        patchData,
      );
      message.success(t("sucCreated"));

      setTimeout(() => {
        onClose();
      }, 800);
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoading3(false);
    }
  };

  const cancelTransferRequest = async () => {
    setLoadingCancelBtn(true);

    try {
      await http.patch(
        `api/inventorytransferrequest/cancel-request?docEntry=${data?.docEntry}`,
      );
      message.success(t("sucCanceledTransfer"));
      setTimeout(() => {
        // resetForm();
        onClose();
      }, 800);
    } catch (error) {
      message.error(error.response.data.message || error.message);
    } finally {
      setLoadingCancelBtn(false);
    }
  };

  if (!data) return null;

  return (
    <Modal
      title={
        <h1 className="font-nunito text-xl font-extrabold text-[#000000]">
          {t("order")} № {data.docNum}
        </h1>
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      closeIcon={<CloseOutlined />}
      width="80%"
      bodyStyle={{ maxHeight: "80vh", overflowY: "auto" }}
    >
      <div className="w-full px-4">
        <Table
          columns={columns}
          dataSource={docLines}
          pagination={false}
          className="border-1 mt-4 w-full border-black"
          scroll={{ x: "100%" }}
        />
        <div className="mt-10 flex items-start justify-between gap-5">
          <div className="flex flex-col gap-3">
            {showShippingLoaders && (
              <div className="flex flex-col items-center justify-end gap-5">
                <div className="flex flex-col gap-3">
                  <p>{t("loadersShipping1")}</p>
                  <Spin spinning={loadingLoaders}>
                    <Select
                      mode="multiple"
                      value={loadersShipping}
                      placeholder={t("loaders")}
                      onChange={(val, label) => {
                        setLoadersShipping(val);
                        setSelectedShippingLoadersAllData(label);
                      }}
                      disabled={!showShippingLoaderBtn}
                      showSearch
                      loading={loadingLoaders}
                      style={{ width: "100%", minHeight: "40px" }}
                      className="min-h-10 max-w-[400px]"
                    >
                      {loadersData.map((item) => (
                        <Select.Option
                          key={item.cardCode}
                          value={item.cardCode}
                          data={item}
                          label={item.cardName}
                        >
                          {item.cardName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Spin>
                </div>
                {showShippingLoaderBtn && (
                  <div className="flex gap-3">
                    <Button
                      type="primary"
                      onClick={handleShippingLoadersBtnClick}
                      disabled={
                        !loadersShipping.length ||
                        docLines.some(
                          (item) => item.fromWarehouseCode !== warehouse,
                        )
                      }
                      loading={loadingLoaderBtn}
                      className="h-9 w-full rounded-lg !bg-[#0A4D68] text-white hover:!opacity-70 disabled:!bg-gray-400 disabled:!text-white sm:w-auto"
                    >
                      {t("patchLoaderShipping")}
                    </Button>
                  </div>
                )}
              </div>
            )}
            {showReceivingLoaders && (
              <div className="flex flex-col items-center justify-end gap-5">
                <div className="flex flex-col gap-3">
                  <p>{t("loadersReceiving2")}</p>
                  <Spin spinning={loadingLoaders}>
                    <Select
                      mode="multiple"
                      value={loadersReceiving}
                      placeholder={t("loaders")}
                      onChange={(val, label) => {
                        setLoadersReceiving(val);
                        setSelectedReceivingLoadersAllData(label);
                      }}
                      disabled={!showReceivingLoaderBtn}
                      showSearch
                      loading={loadingLoaders}
                      style={{ width: "100%", minHeight: "40px" }}
                      className="min-h-10 max-w-[400px]"
                    >
                      {loadersData.map((item) => (
                        <Select.Option
                          key={item.cardCode}
                          value={item.cardCode}
                          data={item}
                          label={item.cardName}
                        >
                          {item.cardName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Spin>
                </div>

                {showReceivingLoaderBtn && (
                  <div className="flex gap-3">
                    <Button
                      type="primary"
                      onClick={handleReceivingLoadersBtnClick}
                      disabled={
                        !loadersReceiving.length ||
                        docLines.some(
                          (item) => item.warehouseCode !== warehouse,
                        )
                      }
                      loading={loadingLoaderBtn}
                      className="h-9 w-full rounded-lg !bg-[#0A4D68] text-white hover:!opacity-70 disabled:!bg-gray-400 disabled:!text-white sm:w-auto"
                    >
                      {t("patchLoaderReceiving")}
                    </Button>
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="flex flex-col gap-5">
            <div className="flex w-full flex-col gap-3 sm:w-auto">
              <p>{t("driver")}</p>
              <Spin spinning={loadingDrivers}>
                <Select
                  value={driverId}
                  placeholder={t("chooseDriver")}
                  onChange={(val) => {
                    setDriverId(val);
                  }}
                  disabled={!isEditDriverAndLoaders}
                  showSearch
                  className="flex h-9 w-full items-center justify-center sm:w-[250px]"
                  options={driversData?.map((item) => ({
                    label: item.cardName,
                    value: item.cardCode,
                  }))}
                />
              </Spin>
            </div>
            <div className="flex w-full flex-col gap-3 sm:w-auto">
              <p>{t("carNumber")}</p>
              <Spin spinning={loadingDrivers}>
                <Select
                  value={carNum}
                  placeholder={t("chooseCar")}
                  onChange={(val) => {
                    setCarNum(val);
                  }}
                  showSearch
                  disabled={!isEditDriverAndLoaders}
                  className="flex h-10 w-full items-center justify-center sm:w-[250px]"
                >
                  {carNumbers.map((item) => (
                    <Select.Option key={item.fldValue} value={item.fldValue}>
                      {item.fldValue}
                    </Select.Option>
                  ))}
                </Select>
              </Spin>
            </div>
          </div>
        </div>

        <div className="mt-5 flex gap-3">
          {isShowLoaderPdfReceiving && (
            <Button
              type="default"
              onClick={() => {
                loadersPdfStockTransfers({ data: pdfData });
              }}
              disabled={!pdfData || !pdfData?.receivingLoaderNames}
              className="h-9 rounded-lg bg-yellow-500 text-white hover:!bg-yellow-600 sm:w-auto"
            >
              <LoadersIcon />
            </Button>
          )}
          {isShowLoaderPdfShipping && (
            <Button
              type="default"
              onClick={() => {
                loadersPdfStockTransfers({ data: pdfData });
              }}
              disabled={!pdfData || !pdfData?.shippingLoaderNames}
              className="h-9 rounded-lg bg-yellow-500 text-white hover:!bg-yellow-600 sm:w-auto"
            >
              <LoadersIcon />
            </Button>
          )}
          {isShowDriverPdf && (
            <Button
              type="default"
              onClick={() => {
                stockTransfersPdf({ data: pdfData });
              }}
              disabled={!pdfData || !driverId}
              className="h-9 rounded-lg bg-green-500 text-white hover:!bg-green-600 sm:w-auto"
            >
              <CarIcon3 />
            </Button>
          )}
        </div>

        <div className="flex items-end justify-end">
          <div className="mt-4 flex gap-3 sm:mt-10">
            {showCancelBtn && (
              <Button
                type="danger"
                onClick={cancelTransferRequest}
                className="h-10 w-full rounded-lg bg-red-600 text-white hover:opacity-70 sm:w-auto"
                loading={loadingCancelBtn}
              >
                {t("cancel")}
              </Button>
            )}

            {showShipBtn && (
              <Button
                type="primary"
                onClick={shipData}
                className="h-10 w-full rounded-lg !bg-[#0A4D68] text-white hover:!opacity-70 disabled:!bg-gray-400 disabled:!text-white sm:w-auto"
                disabled={
                  loading2 ||
                  !loadersShipping.length ||
                  !driverId ||
                  !carNum ||
                  !selectedShippingLoadersAllData.every(
                    (item) => item.data.cardCode,
                  ) ||
                  docLines.some((item) => !item.givingQuantity) ||
                  !shippingLoaderBtnClicked ||
                  docLines.some(
                    (item) =>
                      item.givingQuantity >
                      item.whsAvailableQuantity + item.u_RequestedQuantityWeb,
                  ) ||
                  docLines.some((item) => item.fromWarehouseCode !== warehouse)
                }
                loading={loading2}
              >
                {t("shipData")}
              </Button>
            )}

            {showReceiveBtn && (
              <Button
                type="primary"
                onClick={createStockTransfer}
                className="h-10 w-full rounded-lg !bg-[#0A4D68] text-white hover:!opacity-70 disabled:!bg-gray-400 disabled:!text-white sm:w-auto"
                disabled={
                  // docLines.some((item) => !item.receivedQuantity) ||
                  docLines.some(
                    (item) => item.receivedQuantity > item.givingQuantity,
                  ) ||
                  !selectedReceivingLoadersAllData.every(
                    (item) => item.data.cardCode,
                  ) ||
                  !loadersReceiving.length ||
                  !receivingLoaderBtnClicked ||
                  docLines.some((item) => item.warehouseCode !== warehouse)
                }
                loading={loading3}
              >
                {t("receiveTransfer")}
              </Button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default InventoryTransfersModal;
